export const properties = [
    {
        id: "res-01",
        category: "residential",
        name: "The Mirage Estate",
        location: "Summerlin, Las Vegas, NV",
        price: 18500000,
        beds: 7,
        baths: 9,
        sqft: 14200,
        tag: "Signature Estate",
        image: "https://images.pexels.com/photos/3195642/pexels-photo-3195642.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
        description:
            "A private lakeside compound with infinity pool, private cinema, and a 4,000 sq ft primary wing overlooking the Red Rocks.",
    },
    {
        id: "res-02",
        category: "residential",
        name: "Obsidian House",
        location: "The Ridges, Las Vegas, NV",
        price: 9750000,
        beds: 5,
        baths: 7,
        sqft: 9800,
        tag: "Architect's Collection",
        image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=80",
        description:
            "A minimalist monolith in honed black basalt and walnut. Gallery-grade walls, climate wine cellar, and rooftop observatory.",
    },
    {
        id: "res-03",
        category: "residential",
        name: "Villa di Oro",
        location: "MacDonald Highlands, Henderson, NV",
        price: 24900000,
        beds: 8,
        baths: 11,
        sqft: 18600,
        tag: "Trophy Property",
        image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1400&q=80",
        description:
            "Italianate palazzo on a double ridge lot. Gold-leaf ceilings, imported Calacatta marble, private vineyard and heliport pad.",
    },
    {
        id: "res-04",
        category: "residential",
        name: "Sky Loft at The Martin",
        location: "The Strip, Las Vegas, NV",
        price: 6450000,
        beds: 4,
        baths: 5,
        sqft: 5200,
        tag: "Penthouse",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
        description:
            "Full-floor penthouse with 360° Strip and mountain views. Private elevator, smart home, and two-story great room.",
    },
    {
        id: "res-05",
        category: "residential",
        name: "The Desert Pavilion",
        location: "Ascaya, Henderson, NV",
        price: 12200000,
        beds: 6,
        baths: 8,
        sqft: 11400,
        tag: "Glass Residence",
        image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80",
        description:
            "Floor-to-ceiling glass, cantilevered pool deck, and guest casita. Designed for entertaining at altitude.",
    },
    {
        id: "res-06",
        category: "residential",
        name: "Maison Noir",
        location: "Queensridge, Las Vegas, NV",
        price: 8150000,
        beds: 5,
        baths: 6,
        sqft: 8100,
        tag: "Golf Frontage",
        image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=80",
        description:
            "French-contemporary estate on Badlands Golf. Limestone facade, motor court, and wellness spa wing.",
    },
    {
        id: "com-01",
        category: "commercial",
        name: "Rainbow Tower",
        location: "S. Rainbow Blvd, Las Vegas, NV",
        price: 46000000,
        sqft: 182000,
        tag: "Class A Office",
        image: "https://images.unsplash.com/photo-1762430047160-db0e2670c533?auto=format&fit=crop&w=1400&q=80",
        description:
            "Stabilized Class-A office tower with credit tenancy and structured parking. Below-market rents, 8.4% cap.",
    },
    {
        id: "com-02",
        category: "commercial",
        name: "Gilt Mercantile",
        location: "Downtown Summerlin, NV",
        price: 28400000,
        sqft: 94000,
        tag: "Mixed-Use Retail",
        image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1400&q=80",
        description:
            "Luxury retail concourse with boutique F&B anchors. 98% leased, blue-chip NNN roster.",
    },
    {
        id: "com-03",
        category: "commercial",
        name: "Monarch Industrial Park",
        location: "North Las Vegas, NV",
        price: 74500000,
        sqft: 612000,
        tag: "Logistics Portfolio",
        image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1400&q=80",
        description:
            "Three-building last-mile logistics park leased to investment-grade e-commerce tenants. 10-year WALT.",
    },
    {
        id: "com-04",
        category: "commercial",
        name: "Auric Hotel & Residences",
        location: "Las Vegas Strip, NV",
        price: 185000000,
        sqft: 412000,
        tag: "Hospitality Trophy",
        image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=80",
        description:
            "Boutique 220-key hotel with branded residential condo program. Off-market opportunity with flag flexibility.",
    },
    {
        id: "com-05",
        category: "commercial",
        name: "The Prism Medical Campus",
        location: "Henderson, NV",
        price: 52300000,
        sqft: 220000,
        tag: "Medical Office",
        image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80",
        description:
            "Credit-anchored MOB with long-term HCA leases. Purpose-built, covered parking, recession-resistant asset.",
    },
    {
        id: "com-06",
        category: "commercial",
        name: "Silver District Lofts",
        location: "Arts District, Las Vegas, NV",
        price: 31750000,
        sqft: 138000,
        tag: "Adaptive Reuse",
        image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
        description:
            "Historic masonry building converted to 74 luxury residential lofts with ground floor F&B. Entitled for rooftop expansion.",
    },
];

export const formatPrice = (n) => {
    if (n >= 1_000_000) {
        const v = n / 1_000_000;
        return `$${v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)}M`;
    }
    return `$${n.toLocaleString()}`;
};
